import React, { useState, useEffect } from 'react';
import {Link, useNavigate, useSearchParams} from 'react-router-dom';
import {Alert, AlertTitle, Snackbar} from "@mui/material";



const PasswordRecoveryEntry = () => {

    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const email = searchParams.get("email");
    const baseUrl = searchParams.get("baseUrl");

    const [data, setData] = useState('');
    const [status, setStatus] = useState(0);
    const [alertInfo, setAlertInfo] = useState({open: false, message: '', severity: 'success'});
    const [alertInfo2, setAlertInfo2] = useState({open: false, message: '', severity: 'error'});
    const [password2, setPassword2] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);
    const navigate = useNavigate();


    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertInfo({...alertInfo, open: false});
    };

    const handleAlertClose2 = (event, reason) => {
        //console.log('Entering handleAlertClose2');
        if (reason === 'clickaway') {
            return;
        }
        console.log('alertInfo2.severity:', {alertInfo2}.severity);
        setAlertInfo2({...alertInfo2, open: false});

        if (alertInfo2.severity === 'success') {
            //navigate("/");
            window.location.href = baseUrl;
        }
    };

    const handleUpdatePassword = () => {
        if (password !== password2) {
            setError(true);
            setAlertInfo2({
                open: true,
                message: `Password entries do not match`,
                severity: 'error',
            });
            //console.log('Severity:', {alertInfo2}.severity)
            return false;
        }
        if (!validatePassword(password)) {
            setError(true);
            setAlertInfo2({
                open: true,
                message: `Please enter a valid password (8 characters or more with at least one uppercase, one lowercase, on number, one punctuation)`,
                severity: 'error',
            });
            //console.log('Severity:', {alertInfo2}.severity)
            return false;
        }
        setError(false);
        return true;
    }

    const updatePassword = async (e) => {
        e.preventDefault();
        if (!handleUpdatePassword()) {
            return;
        }
        // console.log('handleUpdatePassword error:', error.error);
        // if (error.error) return;

        try {
            const response = await fetch('/api/submitNewPassword', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({email, token, password}),
            });

            if (response.ok) {
                const data = await response.json();
                setAlertInfo2({
                    open: true,
                    message: `New password saved successfully!`,
                    severity: 'success',
                });
            }
        } catch (err) {
            console.error(err);
            setAlertInfo2({
                open: true,
                message: `Error: ${err.message}`,
                severity: 'error',
            });
        }
    };

    const validatePassword = (password) => {
        const passwordRegex = new RegExp(
            "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$"
        );
        return passwordRegex.test(password);
    }



    useEffect(() => {
        const fetchData = async () => {
            try {
                // Construct URL with query parameters
                const urlString = baseUrl + "/api/passwordRecoveryEntryInit";
                console.log("urlString:" + urlString);
                const url = new URL(urlString);
                url.searchParams.append('email', email);
                url.searchParams.append('token', token);

                // Use the fetch API to make the GET request
                const response = await fetch(url);
                setStatus(response.status);
                if (!response.ok) {
                    //throw new Error(`HTTP error! status: ${response.status}`);
                    console.log("Error:", response.status);
                }
                const result = await response.json();
                console.log("Result:", result);
                if (result.status) {
                    setData(result.status);
                } else if (result.error) {
                    setData(result.error);
                    setAlertInfo({
                        open: true,
                        message: `${result.error}`,
                        severity: 'error',
                    });
                }
            } catch (err) {

            }
        };
        fetchData();
    }, []);

    if ({data}.data !== 'ok') {
        return (
            <Snackbar
                open={alertInfo.open}
                autoHideDuration={6000} // Alert disappears after 6 seconds
                onClose={handleAlertClose}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            >
                {/* Alert component housed within the Snackbar */}
                <Alert
                    onClose={handleAlertClose}
                    severity={alertInfo.severity}
                    variant="filled" // Optional: gives a filled background look
                    sx={{width: '100%'}}
                >
                    <AlertTitle>{alertInfo.severity === 'success' ? 'Success' : 'Error'}</AlertTitle>
                    {alertInfo.message}
                </Alert>
            </Snackbar>
        );
    }
    return (
        <div>
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <form onSubmit={updatePassword} className="p-8 border rounded shadow-md">
                    <div className="mb-4">
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-1 p-2 w-full border rounded-md"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="password2" className="block text-sm font-medium text-gray-700">Repeat Password</label>
                        <input
                            type="password"
                            id="password2"
                            value={password2}
                            onChange={(e) => setPassword2(e.target.value)}
                            className="mt-1 p-2 w-full border rounded-md"
                            required
                        />
                    </div>
                    <button type="submit" className="w-full p-2 bg-blue-500 text-white rounded-md">Save New Password</button>
                </form>
            </div>
            <div>
                <Snackbar
                    open={alertInfo2.open}
                    autoHideDuration={6000} // Alert disappears after 6 seconds
                    onClose={handleAlertClose2}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                >
                    {/* Alert component housed within the Snackbar */}
                    <Alert
                        onClose={handleAlertClose2}
                        severity={alertInfo2.severity}
                        variant="filled" // Optional: gives a filled background look
                        sx={{width: '100%'}}
                    >
                        <AlertTitle>{alertInfo2.severity === 'success' ? 'Success' : 'Error'}</AlertTitle>
                        {alertInfo2.message}
                    </Alert>
                </Snackbar>
            </div>
        </div>
    );
};
//}

export default PasswordRecoveryEntry;